import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '~/lib/auth';
import { ApiError } from '~/lib/api';
import { router } from '~/router';
import './globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Ne jamais rejouer une erreur definitive : reessayer un 403 ou un 404
        // ne fera que retarder l'affichage du message a l'utilisateur.
        if (error instanceof ApiError && error.status < 500 && error.status !== 408) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster
          position="top-right"
          richColors
          closeButton
          // Les notifications doivent etre annoncees aux lecteurs d'ecran.
          toastOptions={{ duration: 5000 }}
        />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
